<template>
  <v-card :disabled="loading">
    <v-toolbar flat>
        <v-toolbar-title>Invoices & Payouts</v-toolbar-title>
    </v-toolbar>
    <v-data-table
        :loading="loading"
        :items="invoices"
        :headers="headers"
        hide-default-footer
    >
        <template #[`item.statusId`]="{item}">
            <InvoiceStatusChip :status="item.statusId" small />
        </template>
        <template #[`item.total`]="{item}">
            {{ item.total | currency(item.currency)}}
        </template>
        <template #[`item.open`]="{item}">
            <invoice-detail :invoice="item">
                <template #activator="{on}">
                    <v-btn icon x-small v-on="on" target="_blank">
                        <v-icon>mdi-eye</v-icon>
                    </v-btn>
                </template>
            </invoice-detail>
        </template>
        <template #foot>
            <tfoot>
                <tr>
                    <td colspan="3" class="font-weight-bold">Invoiced amount</td>
                    <td class="font-weight-bold">
                        {{ order.amountInvoiced | currency(order.currency.currency)}}
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="3" class="font-weight-bold">Not Invoiced amount</td>
                    <td class="font-weight-bold">
                        {{ order.amountNotInvoiced | currency(order.currency.currency)}}
                    </td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="3" class="font-weight-bold">Funds applied</td>
                    <td class="font-weight-bold">
                        {{ order.fundsApplied | currency(order.currency.currency)}}
                    </td>
                    <td></td>
                </tr>
                <tr class="grey white--text">
                    <td colspan="3" class="font-weight-bold">Amount remaining</td>
                    <td class="font-weight-bold">
                        {{ order.amountRemaining | currency(order.currency.currency)}}
                    </td>
                    <td></td>
                </tr>
            </tfoot>
        </template>
        <template #no-data>
            No invoice
        </template>
    </v-data-table>
    <v-card-actions v-if="$can('payout', 'Order')">
        <payout
            v-if="order.statusId != 'cancel'"
            :order="this.order"
            :invoices="invoices"
            @payoutAdded="payoutAdded"
        ></payout>
        <v-spacer />
        <PayoutList :order="order" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Payout from '../orders/Payout.vue'
import PayoutList from '../orders/PayoutList.vue'
import InvoiceDetail from './InvoiceDetail.vue'
import InvoiceStatusChip from './InvoiceStatusChip.vue'
export default {
    name: 'OrderInvoiceCard',
    components: {
        InvoiceDetail,
        InvoiceStatusChip,
        Payout,
        PayoutList
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        invoices: [],
        headers: [
            { text: 'Number', value: 'invoiceNumber'},
            { text: 'Tracking #', value: 'shippingTracking.tracking_id'},
            { text: 'Status', value: 'statusId'},
            { text: 'Total', value: 'total'},
            { text: '', value: 'open'}
        ]
    }),
    computed: {
        ...mapGetters("auth", ["currentUser"]),
        ...mapGetters('invoices', ['loading']),
        invoicedAmount () {
            return this.invoices.reduce((amount, invoice) => amount + invoice.amount + invoice.tax, 0)
        },
        currency () {
            return this.invoices.length ? this.invoices[0].currency : ''
        }
    },
    mounted(){
        this.load()
    },
    methods: {
        ...mapActions('invoices', {
            getInvoiceByOrderId: 'getByOrderId'
        }),
        load(){
            if (this.order.id) {
                this.getInvoiceByOrderId(this.order.id)
                    .then(({invoices}) => {
                        this.invoices = invoices ? invoices.data : []
                    })
            }
        },
        payoutAdded () {
            this.load()
            this.$emit('update')
        }
    }
}
</script>

<style>

</style>